<template>
  <!--begin::Authentication - Multi-steps-->
  <!--begin::Authentication - Multi-steps-->

  <div class="d-flex flex-column flex-lg-row flex-column-fluid stepper stepper-pills stepper-column  bg-white"
    id="kt_create_account_stepper">
    <!--begin::Aside-->

    <div class="d-flex flex-column flex-lg-row-auto w-xl-500px bg-lighten shadow-sm step-none"
      style="height: 100vh!important">
      <!--begin::Wrapper-->

      <div class="d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-500px scroll-y">
        <!--begin::Header-->
        <div class="d-flex flex-row-fluid flex-column flex-center p-10 pt-lg-20">
          <!--begin::Logo-->
          <a href="#" class="mb-10 mb-lg-20">
            <img alt="Logo" src="@/assets/media/logos/qomerxia-logo.png" class="h-50px" />
          </a>
          <!--end::Logo-->
          <!--begin::Nav-->
          <div class="stepper-nav">
            <!--begin::Step 1-->
            <div class="stepper-item current" data-kt-stepper-element="nav">
              <!--begin::Line-->
              <div class="stepper-line w-40px"></div>
              <!--end::Line-->
              <!--begin::Icon-->
              <div class="stepper-icon w-40px h-40px">
                <i class="stepper-check fas fa-check"></i>
                <span class="stepper-number">1</span>
              </div>
              <!--end::Icon-->
              <!--begin::Label-->
              <div class="stepper-label">
                <h3 class="stepper-title">{{ $t('auth.general_society') }}</h3>
                <div class="stepper-desc fw-bold">{{ $t('auth.general_society_details') }}</div>
              </div>
              <!--end::Label-->
            </div>
            <!--end::Step 1-->
            <!--begin::Step 2-->
            <div class="stepper-item" data-kt-stepper-element="nav">
              <!--begin::Line-->
              <div class="stepper-line w-40px"></div>
              <!--end::Line-->
              <!--begin::Icon-->
              <div class="stepper-icon w-40px h-40px">
                <i class="stepper-check fas fa-check"></i>
                <span class="stepper-number">2</span>
              </div>
              <!--end::Icon-->
              <!--begin::Label-->
              <div class="stepper-label">
                <h3 class="stepper-title">{{ $t('auth.address_society') }}</h3>
                <div class="stepper-desc fw-bold">{{ $t('auth.address_society_details') }}</div>
              </div>
              <!--end::Label-->
            </div>
            <!--end::Step 2-->
            <!--begin::Step 3-->
            <div class="stepper-item" data-kt-stepper-element="nav">
              <!--begin::Line-->
              <div class="stepper-line w-40px"></div>
              <!--end::Line-->
              <!--begin::Icon-->
              <div class="stepper-icon w-40px h-40px">
                <i class="stepper-check fas fa-check"></i>
                <span class="stepper-number">3</span>
              </div>
              <!--end::Icon-->
              <!--begin::Label-->
              <div class="stepper-label">
                <h3 class="stepper-title">{{ $t('auth.creation_admin') }}</h3>
                <div class="stepper-desc fw-bold">{{ $t('auth.creation_admin_details') }}</div>
              </div>
              <!--end::Label-->
            </div>
            <!--end::Step 3-->
            <!--begin::Step 4-->
            <div class="stepper-item" data-kt-stepper-element="nav">
              <!--begin::Line-->
              <div class="stepper-line w-40px"></div>
              <!--end::Line-->
              <!--begin::Icon-->
              <div class="stepper-icon w-40px h-40px">
                <i class="stepper-check fas fa-check"></i>
                <span class="stepper-number">4</span>
              </div>
              <!--end::Icon-->
              <!--begin::Label-->
              <div class="stepper-label">
                <h3 class="stepper-title">{{ $t('auth.pieces') }}</h3>
                <div class="stepper-desc fw-bold">{{ $t('auth.pieces_details') }}</div>
              </div>
              <!--end::Label-->
            </div>
            <!--end::Step 4-->
            <!--begin::Step 5-->
            <div class="stepper-item" data-kt-stepper-element="nav">
              <!--begin::Line-->
              <div class="stepper-line w-40px"></div>
              <!--end::Line-->
              <!--begin::Icon-->
              <div class="stepper-icon w-40px h-40px">
                <i class="stepper-check fas fa-check"></i>
                <span class="stepper-number">5</span>
              </div>
              <!--end::Icon-->
              <!--begin::Label-->
              <div class="stepper-label">
                <h3 class="stepper-title">{{ $t('auth.checking') }}</h3>
                <div class="stepper-desc fw-bold">{{ $t('auth.check_data') }}</div>
              </div>
              <!--end::Label-->
            </div>
            <!--end::Step 5-->
            <!--begin::Step 5-->
            <div class="stepper-item" data-kt-stepper-element="nav">
              <!--begin::Line-->
              <div class="stepper-line w-40px"></div>
              <!--end::Line-->
              <!--begin::Icon-->
              <div class="stepper-icon w-40px h-40px">
                <i class="stepper-check fas fa-check"></i>
                <span class="stepper-number">6</span>
              </div>
              <!--end::Icon-->
              <!--begin::Label-->
              <div class="stepper-label">
                <h3 class="stepper-title">{{ $t('auth.end') }}</h3>
                <div class="stepper-desc fw-bold">{{ $t('auth.congratulate') }}</div>
              </div>
              <!--end::Label-->
            </div>
            <!--end::Step 5-->
          </div>
          <!--end::Nav-->
        </div>
        <!--end::Header-->
        <!--begin::Illustration-->
        <!--        <div class="d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-150px min-h-lg-300px" style="background-image: url(assets/media/illustrations/sketchy-1/16.png"></div>-->
        <!--end::Illustration-->
      </div>
      <!--end::Wrapper-->
    </div>
    <!--begin::Aside-->
    <!--begin::Body-->
    <div class="d-flex flex-column flex-lg-row-fluid py-10 " style="height: 100vh!important">
      <!--begin::Content-->
      <div class=" d-flex container-fluid  align-items-stretch justify-content-between">
        <div class="d-flex align-items-center ms-auto me-1 me-lg-3">
          <!--begin::Menu wrapper-->
          <div
            class="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px"
            data-kt-menu-trigger="hover" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
            <!--begin::Svg Icon | path: icons/duotune/general/gen025.svg-->
            <img class="h-20px w-20px rounded-sm" :src="currentLanguage.img" alt="" />
            <!--end::Svg Icon-->
          </div>
          <!--begin::Menu-->
          <div class="menu menu-sub menu-sub-dropdown menu-column w-150px" data-kt-menu="true">
            <!--begin:Nav-->
            <div v-for="lang in langs" :key="lang.code" class="menu-item px-3">
              <a @click.prevent="changeLang(lang)" href="#" class="menu-link d-flex px-5 active">
                <span class="symbol symbol-20px me-4">
                  <img class="rounded-1" :src="lang.img" :alt="$t(lang.title)" />
                </span>{{ $t(lang.title) }}</a>
            </div>
            <!--end:Nav-->
          </div>
          <!--end::Menu-->
          <!--end::Menu wrapper-->
        </div>

        <!--end::Wrapper-->
      </div>
      <div class="d-flex flex-center flex-column flex-column-fluid">
        <!--begin::Wrapper-->
        <div class="w-lg-700px p-10 p-lg-15 mx-auto">
          <!--begin::Form-->
          <form class="my-auto pb-5" novalidate="novalidate" id="kt_create_account_form">
            <!--begin::Step 1-->
            <div class="current" data-kt-stepper-element="content">
              <!--begin::Wrapper-->
              <div style="height : 64vh !important;" class="w-100 scroll-y me-n7 pe-7">
                <!--begin::Heading-->
                <div class="pb-10 pb-lg-15">
                  <!--begin::Title-->
                  <h2 class="fw-bolder d-flex align-items-center text-dark">{{ $t('auth.general_society') }}
                    <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                      :title="$t('auth.general_society_details')"></i>
                  </h2>

                  <div class="text-muted fw-bold fs-6">{{ $t('auth.general_society_details') }}</div>
                  <div v-if="$i18n.locale === 'fr'" class="fw-bold fs-5">Les champs marqués par (<span
                      class="text-danger"> * </span>) sont <span class="text-danger"> obligatoires </span></div>
                  <div v-if="$i18n.locale === 'en'" class="fw-bold fs-5">Fields marked with (<span class="text-danger"> *
                    </span>) are <span class="text-danger"> mandatory </span></div>
                </div>

                <div class="fv-row mb-5">
                  <label class="form-label mb-3 required">{{ $t('auth.name_society') }}</label>
                  <input v-model="form.society_name" type="text" class="form-control form-control-lg form-control-solid"
                    ref="society_name" name="society_name" />
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="fv-row mb-5">
                      <label class="fs-6 fw-bold form-label required">{{ $t('auth.matricule_number') }}</label>
                      <input v-model="form.matricule_number" name="matricule_number"
                        class="form-control form-control-lg form-control-solid" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="fv-row mb-5">
                      <label class="form-label mb-3 required">{{ $t('auth.rccm_number') }}</label>
                      <input v-model="form.rccm_number" type="text"
                        class="form-control form-control-lg form-control-solid" name="rccm_number" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-5">
                    <!--begin::Label-->
                    <label class="fs-6 fw-bold form-label">{{ $t('auth.tva_number') }}</label>
                    <input v-model="form.tva_number" name="tva_number"
                      class="form-control form-control-lg form-control-solid" />
                    <!--end::Input wrapper-->
                  </div>
                  <div class="col-md-6 mb-5">
                    <!--begin::Label-->
                    <label class="fs-6 fw-bold form-label ">{{ $t('auth.website') }}</label>
                    <input v-model="form.website" name="website"
                      class="form-control form-control-lg form-control-solid" />
                  </div>
                </div>
                <div class="row">
                  <!--begin::Col-->
                  <div class="col-md-12 mb-5">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold form-label required">{{ $t('auth.responsable_gender') }}</label>
                      <select name="responsable_gender" v-model="form.responsable_gender"
                        class="form-select form-select-lg form-select-solid " data-control="select2"
                        :data-placeholder="$t('auth.responsable_gender')" data-allow-clear="true">
                        <option></option>
                        <option value="male">{{ $t('contacts.gender_men') }}</option>
                        <option value="female">{{ $t('contacts.gender_women') }}</option>
                      </select>
                    </div>
                  </div>
                  <!--end::Col-->
                  <!--begin::Col-->

                  <!--end::Col-->
                </div>
                <div class="row">
                  <div class="col-md-6 mb-5">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold form-label required">{{ $t('auth.responsable_lastname') }}</label>
                      <input v-model="form.responsable_lastname" name="responsable_lastname"
                             class="form-control form-control-lg form-control-solid" />
                    </div>
                  </div>
                  <div class="col-md-6 mb-5">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold form-label required">{{ $t('auth.responsable_firstname') }}</label>
                      <input v-model="form.responsable_firstname" name="responsable_firstname"
                             class="form-control form-control-lg form-control-solid" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <!--begin::Col-->
                  <div class="col-md-6 ">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold form-label required">{{ $t('auth.responsable_email') }}</label>
                      <input v-model="form.responsable_email" type="email" name="responsable_email"
                        class="form-control form-control-lg form-control-solid" />
                    </div>
                  </div>
                  <!--end::Col-->
                  <!--begin::Col-->
                  <div class="col-md-6 ">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold form-label required">{{ $t('auth.responsable_phone') }}</label>
                      <vue-tel-input @country-changed="secondInputCountryChanged" :inputOptions="options"
                        @input="secondInputChanged" :autoDefaultCountry="true" id="responsable_phone"
                        class="form-control form-control-solid" name="responsable_phone"
                        v-model="form.responsable_phone"></vue-tel-input>
                    </div>
                  </div>

                  <label class="fs-6 fw-bold form-label required mt-4">{{ $t('auth.domain') }}</label>

                  <div class="fv-row mb-5">
                    <div class="input-group">
                      <input type="text" name="domain" v-model="form.domain" class="form-control"
                        :data-placeholder="$t('auth.domain_prefix')" aria-label="Recipient's username"
                        aria-describedby="basic-addon2" />
                      <span class="input-group-text" id="basic-addon2">{{ backUrl }}</span>
                    </div>
                  </div>
                  <!--end::Col-->
                </div>

              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::Step 1-->
            <!--begin::Step 2-->
            <div class="" data-kt-stepper-element="content">
              <!--begin::Wrapper-->
              <div style="height : 64vh !important;" class="w-100 scroll-y me-n7 pe-7">
                <div class="w-100">
                  <!--begin::Heading-->
                  <div class="pb-10 pb-lg-15">
                    <!--begin::Title-->
                    <h2 class="fw-bolder d-flex align-items-center text-dark">{{ $t('auth.address_society') }}
                    </h2>
                    <!--end::Title-->
                    <!--begin::Notice-->
                    <div class="text-muted fw-bold fs-6">{{ $t('auth.address_society_details') }}</div>
                    <div v-if="$i18n.locale === 'fr'" class="fw-bold fs-5">Les champs marqués par (<span
                        class="text-danger"> * </span>) sont <span class="text-danger"> obligatoires </span></div>
                    <div v-if="$i18n.locale === 'en'" class="fw-bold fs-5">Fields marked with (<span class="text-danger">
                        * </span>) are <span class="text-danger"> mandatory </span></div>
                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
                  <!--begin::Input group-->
                  <div class="row">
                    <!--begin::Col-->
                    <div class="col-md-6 mb-5">
                      <div class="fv-row">
                        <label class="fs-6 fw-bold form-label required">{{ $t('auth.society_email') }}</label>
                        <input v-model="form.society_email" name="society_email"
                          class="form-control form-control-lg form-control-solid" />
                      </div>
                    </div>
                    <!--end::Col-->
                    <!--begin::Col-->
                    <div class="col-md-6 mb-5">
                      <div class="fv-row">
                        <label class="fs-6 fw-bold form-label required">{{ $t('auth.society_phone') }}</label>
                        <vue-tel-input @country-changed="inputCountryChanged" :inputOptions="options"
                          @input="inputChanged" :autoDefaultCountry="true" id="society_phone"
                          class="form-control form-control-solid" name="society_phone"
                          v-model="form.society_phone"></vue-tel-input>
                      </div>
                    </div>
                    <!--end::Col-->
                  </div>
                  <div class="row ">
                    <!--begin::Col-->
                    <div class="col-md-6 mb-5">
                      <div class="fv-row">
                        <label class="fs-6 fw-bold form-label required">{{ $t('auth.country') }}</label>
                        <select name="country" v-model="form.country"
                          class="form-select form-select-lg form-select-solid " data-control="select2"
                          data-placeholder="Selectionner un pays" data-allow-clear="true">
                          <option></option>
                          <option v-for="country in getCountries" :key="country.id" :value="country.id">{{ country.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <!--end::Col-->
                    <!--begin::Col-->
                    <div class="col-md-6 mb-5">
                      <div class="fv-row">
                        <label class="fs-6 fw-bold form-label required">{{ $t('auth.city') }}</label>
                        <input v-model="form.city" name="city" class="form-control form-control-lg form-control-solid" />
                      </div>
                    </div>
                    <!--end::Col-->
                  </div>
                  <div class="row mb-5">
                    <div class="col-md-8">
                      <div class="fv-row">
                        <label class="fs-6 fw-bold form-label required">{{ $t('auth.address') }}</label>
                        <input v-model="form.address" name="address"
                          class="form-control form-control-lg form-control-solid" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="fv-row">
                        <label class="fs-6 fw-bold form-label">{{ $t('auth.zipcode') }}</label>
                        <input v-model="form.zipcode" name="zipcode"
                          class="form-control form-control-lg form-control-solid" />
                      </div>
                    </div>
                  </div>
                  <div class="row mt-5" v-if="isBeninCountry">
                    <hr>
                    <div class="card-title">
                      <h3 class="card-label">{{ $t('normalized.title') }}</h3>
                    </div>
                    <div class="fv-row mb-5">
                      <label class="fs-6 fw-bold form-label">{{ $t('normalized.forms.ifu') }}</label>
                      <input v-model="dataInvoice.ifu" name="ifu" class="form-control form-control-lg form-control-solid"
                        required />
                    </div>
                    <div class="fv-row mb-5">
                      <label class="fs-6 fw-bold form-label">{{ $t('normalized.forms.tokenApi') }}</label>
                      <input v-model="dataInvoice.tokenApi" name="tokenApi" class="form-control form-control-lg form-control-solid"
                        required />
                    </div>
                    <div class="fv-row mb-5">
                      <label class="fs-6 fw-bold form-label">{{ $t('normalized.forms.defaultTaxe') }}</label>
                      <select v-model="dataInvoice.defaultTaxe" name="type_taxe"
                        class="form-select form-select-lg form-select-solid " data-control="select2"
                        :data-placeholder="$t('normalized.forms.defaultTaxe')" data-allow-clear="true">
                        <option value="A">A - EXONERE</option>
                        <option value="B">B - TAXABLE 18%</option>
                        <option value="C">C - EXPORTATION</option>
                        <option value="D">D - TVA REGIME D'EXCEPTION 18%</option>
                        <option value="E">E - RIGIME TPS</option>
                        <option value="F">F - RESERVE</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::Step 2-->
            <!--begin::Step 3-->
            <div class="" data-kt-stepper-element="content">
              <!--begin::Wrapper-->
              <div style="height : 64vh !important;" class="w-100 scroll-y me-n7 pe-7">
                <div class="w-100">
                  <!--begin::Heading-->
                  <div class="pb-10 pb-lg-15">
                    <!--begin::Title-->
                    <h2 class="fw-bolder d-flex align-items-center text-dark">{{ $t('auth.creation_admin') }}
                      <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                        :title="$t('auth.creation_admin_details')"></i>
                    </h2>
                    <!--end::Title-->
                    <!--begin::Notice-->
                    <div class="text-muted fw-bold fs-6">{{ $t('auth.creation_admin_details') }}</div>
                    <div v-if="$i18n.locale === 'fr'" class="fw-bold fs-5">Les champs marqués par (<span
                        class="text-danger"> * </span>) sont <span class="text-danger"> obligatoires </span></div>
                    <div v-if="$i18n.locale === 'en'" class="fw-bold fs-5">Fields marked with (<span class="text-danger">
                        * </span>) are <span class="text-danger"> mandatory </span></div>

                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
                  <div class="row">
                    <!--begin::Col-->
                    <div class="col-md-12 mb-5">
                      <div class="fv-row">
                        <label class="fs-6 fw-bold form-label required">{{ $t('auth.gender') }}</label>
                        <select name="gender" v-model="form.gender"
                          class="form-select kt_select2 form-select-lg form-select-solid" data-control="select2"
                          data-placeholder="Genre" data-allow-clear="true">
                          <option></option>
                          <option value="male">{{ $t('contacts.gender_men') }}</option>
                          <option value="female">{{ $t('contacts.gender_women') }}</option>
                        </select>
                      </div>
                    </div>
                    <!--end::Col-->
                    <!--begin::Col-->

                    <!--end::Col-->
                  </div>
                  <div class="row">
                    <div class="col-md-6 mb-5">
                      <div class="fv-row">
                        <label class="fs-6 fw-bold form-label required">{{ $t('auth.lastname') }}</label>
                        <input v-model="form.lastname" name="admin_lastname"
                               class="form-control form-control-lg form-control-solid" />
                      </div>
                    </div>
                    <div class="col-md-6 mb-5">
                      <div class="fv-row">
                        <label class="fs-6 fw-bold form-label required">{{ $t('auth.firstname') }}</label>
                        <input v-model="form.firstname" name="admin_firstname"
                               class="form-control form-control-lg form-control-solid" />
                      </div>
                    </div>
                  </div>
                  <div class="fw-row mb-5">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold form-label required">{{ $t('auth.email') }}</label>
                      <input v-model="form.email" name="admin_email"
                        class="form-control form-control-lg form-control-solid" />
                    </div>
                  </div>
                  <div class="fw-row">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold form-label required">{{ $t('auth.responsable_phone') }}</label>
                      <vue-tel-input @country-changed="thirstInputCountryChanged" :inputOptions="options"
                        @input="thirstInputChanged" :autoDefaultCountry="true" id="admin_phone"
                        class="form-control form-control-solid" name="admin_phone" v-model="form.phone"></vue-tel-input>
                    </div>
                  </div>
                </div>
              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::Step 3-->
            <!--begin::Step 4-->
            <div class="" data-kt-stepper-element="content">
              <!--begin::Wrapper-->
              <div style="height : 64vh !important;" class="w-100 scroll-y me-n7 pe-7">
                <div class="w-100">
                  <div class="pb-10 pb-lg-15">
                    <!--begin::Title-->
                    <h2 class="fw-bolder d-flex align-items-center text-dark">{{ $t('auth.pieces') }}
                      <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                        :title="$t('auth.pieces_details')"></i>
                    </h2>
                    <!--end::Title-->
                    <!--begin::Notice-->
                    <div class="text-muted fw-bold fs-6">{{ $t('auth.pieces_details') }}</div>
                    <div v-if="$i18n.locale === 'fr'" class="fw-bold fs-5">Les champs marqués par (<span
                        class="text-danger"> * </span>) sont <span class="text-danger"> obligatoires </span></div>
                    <div v-if="$i18n.locale === 'en'" class="fw-bold fs-5">Fields marked with (<span class="text-danger">
                        * </span>) are <span class="text-danger"> mandatory </span></div>
                    <!--end::Notice-->
                  </div>
                  <!--begin::Input group-->
                  <div class="row mb-10">
                    <div class="fv-row">
                      <label class="form-label required">{{ $t('auth.matricule_file') }}</label>
                      <attach-file name="ifu_file" :max-files="1" :max-sizes="300" v-model="form.ifu_file"
                        id="ifu_file"></attach-file>
                    </div>
                  </div>
                  <div class="row mb-10">
                    <div class="fv-row">
                      <label class="form-label required">{{ $t('auth.rccm_file') }}</label>
                      <attach-file name="rccm_file" :max-files="1" :max-sizes="300" v-model="form.rccm_file"
                        id="rccm_file" :files="form.rccm_file"></attach-file>
                    </div>
                  </div>
                  <div class="row mb-10">
                    <div class="fv-row">
                      <label class="form-label required">{{ $t('auth.address_file') }}</label>
                      <attach-file name="address_file" :max-files="1" :max-sizes="300" v-model="form.address_file"
                        id="address_file" :files="form.address_file"></attach-file>
                    </div>
                  </div>
                  <div class="fv-row">
                    <div class="d-flex flex">
                      <div class="checkbox-inline">
                        <label class="checkbox checkbox-outline checkbox-success">
                          <input v-model="form.condition" type="checkbox" name="condition" />
                          <span></span>
                        </label>
                      </div>
                      <div style="margin-left: 10px!important">
                        {{ $t('auth.read_agree') }}
                        <a style="color: #2483b4 !important;cursor:pointer" href="/termes-and-conditions"
                          target="_blank">{{ $t('auth.cgu') }} </a>
                        {{ $t('auth.accept_cgu') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::Step 4-->
            <!--begin::Step 5-->
            <div class="" data-kt-stepper-element="content">
              <!--begin::Wrapper-->
              <div style="height : 64vh !important;" class="w-100 scroll-y me-n7 pe-7">
                <div class="w-100">
                  <!--begin::Heading-->
                  <div class="pb-8 pb-lg-10">
                    <!--begin::Title-->
                    <h2 class="fw-bolder text-dark">{{ $t('auth.checking') }}</h2>
                    <!--end::Title-->
                    <!--begin::Notice-->
                    <div class="text-muted fw-bold fs-6">{{ $t('auth.check_data') }}</div>
                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
                  <!--begin::Body-->
                  <div class="mb-0">
                    <!--begin::Text-->
                    <div class="row mb-10">
                      <div class="col-md-6">
                        <h4 class="mb-5">{{ $t('auth.general_society') }}</h4>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.name_society') }} : </span>
                          <span class="text-gray-600"> {{ form.society_name }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.matricule_number') }} : </span>
                          <span class="text-gray-600"> {{ form.matricule_number }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2 "> {{ $t('auth.rccm_number') }} : </span>
                          <span class="text-gray-600"> {{ form.rccm_number }}</span>
                        </div>
                        <div class="fw-row mb-2 ">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.tva_number') }} : </span>
                          <span class="text-gray-600"> {{ form.tva_number }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold"> {{ $t('auth.website') }} : </span>
                          <span class="text-gray-600"> {{ form.website }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.responsable_gender') }} : </span>
                          <span class="text-gray-600"> {{ form.responsable_gender === 'male' ? 'male' : 'female' }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2 "> {{ $t('auth.responsable_lastname') }} : </span>
                          <span class="text-gray-600"> {{ form.responsable_lastname }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2 "> {{ $t('auth.responsable_firstname') }} : </span>
                          <span class="text-gray-600"> {{ form.responsable_firstname }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2 "> {{ $t('auth.responsable_email') }} : </span>
                          <span class="text-gray-600"> {{ form.responsable_email }}</span>
                        </div>
                        <div class="fw-row">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.responsable_phone') }} : </span>
                          <span class="text-gray-600"> {{ form.responsable_phone }}</span>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <h4 class="mb-5">{{ $t('auth.address_society') }}</h4>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2 "> {{ $t('auth.society_email') }} : </span>
                          <span class="text-gray-600"> {{ form.society_email }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.society_phone') }} : </span>
                          <span class="text-gray-600"> {{ form.society_phone }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2 "> {{ $t('auth.country') }} : </span>
                          <span class="text-gray-600"> {{ getCountries.find(x => x.id === form.country) ?
                            getCountries.find(x => x.id === form.country).name : "" }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.city') }} : </span>
                          <span class="text-gray-600"> {{ form.city }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2 "> {{ $t('auth.address') }} : </span>
                          <span class="text-gray-600"> {{ form.address }}</span>
                        </div>
                        <div class="fw-row mb-10">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.zipcode') }} : </span>
                          <span class="text-gray-600"> {{ form.zipcode }}</span>
                        </div>

                      </div>
                    </div>
                    <div class="row mb-10"  v-if="isBeninCountry">
                      <h4 class="mb-5">{{ $t('normalized.title') }}</h4>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('normalized.forms.ifu') }} : </span>
                          <span class="text-gray-600"> {{ dataInvoice.ifu }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('normalized.forms.tokenApi') }} : </span>
                          <span class="text-gray-600"> {{ dataInvoice.tokenApi }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2 "> {{ $t('normalized.forms.defaultTaxe') }} : </span>
                          <span class="text-gray-600"> {{ (dataInvoice.defaultTaxe == 'A') ? 'A - EXONERE' : (dataInvoice.defaultTaxe == 'B') ? 'B - TAXABLE 18%' : (dataInvoice.defaultTaxe == 'C') ? 'C - EXPORTATION' : (dataInvoice.defaultTaxe == 'D') ? 'D - TVA REGIME D\'EXCEPTION 18%' : (dataInvoice.defaultTaxe == 'E') ? 'E - RIGIME TPS' : 'F - RESERVE' }}</span>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <h4 class="mb-5">{{ $t('auth.creation_admin') }}</h4>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2 "> {{ $t('auth.gender') }} : </span>
                          <span class="text-gray-600"> {{ form.gender === 'male' ? 'Homme' : 'Femme' }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.lastname') }} : </span>
                          <span class="text-gray-600"> {{ form.lastname }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.firstname') }} : </span>
                          <span class="text-gray-600"> {{ form.firstname }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2 "> {{ $t('auth.email') }} : </span>
                          <span class="text-gray-600"> {{ form.email }}</span>
                        </div>
                        <div class="fw-row mb-2">
                          <span class="fs-5 fw-bold mr-2"> {{ $t('auth.phone') }} : </span>
                          <span class="text-gray-600"> {{ form.phone }}</span>
                        </div>
                      </div>
                    </div>

                  </div>
                  <!--end::Body-->
                </div>
              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::Step 5-->
            <!--begin::Step 5-->
            <div class="" data-kt-stepper-element="content">
              <!--begin::Wrapper-->
              <div style="height : 64vh !important;" class="w-100 scroll-y me-n7 pe-7">
                <div class="w-100">
                  <!--begin::Heading-->
                  <div class="pb-8 pb-lg-10">
                    <!--begin::Title-->
                    <h2 class="fw-bolder text-dark">{{ $t('auth.end') }}</h2>
                    <!--end::Title-->
                    <!--begin::Notice-->
                    <div class="text-muted fw-bold fs-6">{{ $t('auth.congratulate') }}
                    </div>
                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
                  <!--begin::Body-->
                  <div class="mb-0">
                    <!--begin::Alert-->
                    <!--begin::Notice-->
                    <div class="notice d-flex bg-light-success rounded border-success border border-dashed p-6">
                      <!--begin::Icon-->
                      <!--begin::Svg Icon | path: icons/duotune/general/gen044.svg-->
                      <span class="svg-icon svg-icon-2tx svg-icon-success me-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)"
                            fill="currentColor" />
                          <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)"
                            fill="currentColor" />
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                      <!--end::Icon-->
                      <!--begin::Wrapper-->
                      <div class="d-flex flex-stack flex-grow-1">
                        <!--begin::Content-->
                        <div class="fw-bold">
                          <h4 class="text-gray-900 fw-bolder">{{ $t('inscription_welcome') }}</h4>
                          <div class="fs-6 text-gray-700">
                            {{ $t('inscription_check') }}
                          </div>
                        </div>
                        <!--end::Content-->
                      </div>
                      <!--end::Wrapper-->
                    </div>
                    <!--end::Notice-->
                    <!--end::Alert-->
                  </div>
                  <!--end::Body-->
                </div>
              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::Step 5-->
            <!--begin::Actions-->
            <div class="d-flex flex-stack pt-15">
              <div class="mr-2">
                <button type="button" class="btn btn-lg btn-light-primary me-3" data-kt-stepper-action="previous">
                  <!--begin::Svg Icon | path: icons/duotune/arrows/arr063.svg-->
                  <span class="svg-icon svg-icon-4 me-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="11" width="13" height="2" rx="1" fill="currentColor" />
                      <path
                        d="M8.56569 11.4343L12.75 7.25C13.1642 6.83579 13.1642 6.16421 12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75L5.70711 11.2929C5.31658 11.6834 5.31658 12.3166 5.70711 12.7071L11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25C13.1642 17.8358 13.1642 17.1642 12.75 16.75L8.56569 12.5657C8.25327 12.2533 8.25327 11.7467 8.56569 11.4343Z"
                        fill="currentColor" />
                    </svg>
                  </span>
                  {{ $t('previous') }}
                </button>
              </div>
              <div>
                <button type="button" class="btn btn-lg btn-primary" data-kt-stepper-action="submit">
                  <span class="indicator-label">{{ $t('send') }}
                    <span class="svg-icon svg-icon-4 ms-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)"
                          fill="currentColor" />
                        <path
                          d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                          fill="currentColor" />
                      </svg>
                    </span>
                  </span>
                  <span class="indicator-progress">{{ $t('loading') }}
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
                <button type="button" class="btn btn-lg btn-primary" data-kt-stepper-action="next">Continue
                  <!--begin::Svg Icon | path: icons/duotune/arrows/arr064.svg-->
                  <span class="svg-icon svg-icon-4 ms-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)"
                        fill="currentColor" />
                      <path
                        d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                        fill="currentColor" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
            <!--end::Actions-->
          </form>
          <!--end::Form-->
        </div>
        <!--end::Wrapper-->
      </div>
      <!--end::Content-->
      <!--begin::Footer-->
      <div class="d-flex flex-center flex-wrap fs-6 p-5 pb-0">
        <!--begin::Links-->
        <div class="d-flex flex-center fw-bold fs-6">
          <span class="text-muted text-hover-primary px-2" >©{{ new Date().getFullYear() }}</span>

        </div>
        <!--end::Links-->
      </div>
      <!--end::Footer-->
    </div>
    <!--end::Body-->
  </div>
  <!--end::Authentication - Multi-steps-->
</template>
<script>
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';
import AttachFile from '@/components/AttachFile.vue'
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CreateAccount",
  data() {
    return {
      backUrl: process.env.VUE_APP_PORT ? process.env.VUE_APP_HOST + ':' + process.env.VUE_APP_PORT : process.env.VUE_APP_HOST,
      form: {
        society_name: "",
        society_email: "",
        society_phone: "",
        society_phone_code: "",
        responsable_phone_code: "",
        ifu_file: [],
        rccm_file: [],
        address_file: [],
        name_society: "",
        matricule_number: "",
        rccm_number: "",
        responsable_gender: "",
        responsable_lastname: "",
        responsable_firstname: "",
        responsable_email: "",
        responsable_phone: "",
        address: "",
        city: null,
        zipcode: "",
        tva_number: "",
        website: "",
        domain: "",
        country: "",
        gender: "",
        lastname: "",
        firstname: "",
        phone: "",
        phone_code: "",
        condition: false
      },
      dataInvoice: {
        ifu: null,
        tokenApi: null,
        defaultTaxe: null
      },
      isBeninCountry: false,
      options: {
        placeholder: "Ex : 97 97 00 00",
        showDialCode: true
      },
      getCountries: [],
      langs: {
        en: {
          'img': '/assets/media/united-states.svg',
          'title': 'header.language.english',
          'code': 'en'
        },
        fr: {
          'img': '/assets/media/france.svg',
          'title': 'header.language.french',
          'code': 'fr'
        },
      }
    }

  },
  components: {
    VueTelInput,
    AttachFile
  },

  computed: {
    currentLanguage() {
      return this.langs[this.$i18n?.locale]
    },
  },
  async mounted() {

    this.initSelect2()
    await this.loadCountries()
    this.validateCreateAccountForm()
  },
  methods: {

    ...mapActions('auth', [
      'createAccount'
    ]),
    ...mapActions('shop', [
      'addShopNormalizedKey',
    ]),

    changeLang(lang) {
      this.$i18n.locale = lang.code
      localStorage.setItem('locale', lang.code)
    },
    async loadCountries() {
      window.axiosDefault.get('get/countries').then((response) => {
        this.getCountries = response.data.countries
      }).catch((err) => {

      })
    },

    validateCreateAccountForm() {
      var e, t, i, o, s, r, a = [];
      (e = document.querySelector("#kt_modal_create_account")) && new bootstrap.Modal(e), t = document.querySelector("#kt_create_account_stepper"), i = t.querySelector("#kt_create_account_form"), o = t.querySelector('[data-kt-stepper-action="submit"]'), s = t.querySelector('[data-kt-stepper-action="next"]'), (r = new KTStepper(t)).on("kt.stepper.changed", ((e) => {
        5 === r.getCurrentStepIndex() ? (o.classList.remove("d-none"), o.classList.add("d-inline-block"), s.classList.add("d-none")) : 6 === r.getCurrentStepIndex() ? (o.classList.add("d-none"), s.classList.add("d-none")) : (o.classList.remove("d-inline-block"), o.classList.remove("d-none"), s.classList.remove("d-none"))
      })), r.on("kt.stepper.next", ((e) => {
        var t = a[e.getCurrentStepIndex() - 1];
        t ? t.validate().then(((t) => {
          "Valid" == t ? (e.goNext(), KTUtil.scrollTop()) : Swal.fire({
            text: i18n.global.t('formValidation.error_alert'),
            icon: "error",
            buttonsStyling: !1,
            confirmButtonText: "Ok!",
            customClass: { confirmButton: "btn btn-light" }
          }).then((() => {
            KTUtil.scrollTop()
          }))
        })) : (e.goNext(), KTUtil.scrollTop())
      })), r.on("kt.stepper.previous", ((e) => {
        e.goPrevious(), KTUtil.scrollTop()
      })),
        a.push(FormValidation.formValidation(i, {
          fields: {
            society_name: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                }
              }
            },
            matricule_number: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                }
              }
            },
            rccm_number: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                }
              }
            },
            responsable_gender: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                }
              }
            },
            responsable_lastname: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                }
              }
            },
            responsable_firstname: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                }
              }
            },
            responsable_email: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                },
                emailAddress: {
                  message: i18n.global.t('formValidation.field_must_be_email')
                }
              }
            },
            responsable_phone: {
              validators: {
                callback: {
                  message: i18n.global.t('formValidation.phone_number_not_valid'),
                  callback: (value, validator, $field) => {
                    let number = this.form.responsable_phone.replace(this.form.responsable_phone_code, '')
                    return number.trim().length ? true : false
                  }
                },
              }
            },
            domain: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                },
              }
            },
          },
          plugins: {
            trigger: new FormValidation.plugins.Trigger,
            bootstrap: new FormValidation.plugins.Bootstrap5({
              rowSelector: ".fv-row",
              eleInvalidClass: "",
              eleValidClass: ""
            }),
          }
        })),
        a.push(FormValidation.formValidation(i, {
          fields: {
            society_email: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                },
                emailAddress: {
                  message: i18n.global.t('formValidation.field_must_be_email')
                }
              }
            },
            society_phone: {
              validators: {
                callback: {
                  message: i18n.global.t('formValidation.phone_number_not_valid'),
                  callback: (value, validator, $field) => {
                    let number = this.form.society_phone.replace(this.form.society_phone_code, '')
                    return number.trim().length ? true : false
                  }
                },
              }
            },
            country: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                },
              }
            },
            city: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                },
              }
            },
            address: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                },
              }
            },
          },
          plugins: {
            trigger: new FormValidation.plugins.Trigger,
            bootstrap: new FormValidation.plugins.Bootstrap5({
              rowSelector: ".fv-row",
              eleInvalidClass: "",
              eleValidClass: ""
            })
          }
        })),
        a.push(FormValidation.formValidation(i, {
          fields: {
            gender: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                }
              }
            },
            admin_lastname: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                }
              }
            },
            admin_firstname: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                }
              }
            },
            admin_email: {
              validators: {
                notEmpty: {
                  message: i18n.global.t('formValidation.field_required')
                },
                emailAddress: {
                  message: i18n.global.t('formValidation.field_must_be_email')
                }
              }
            },
            admin_phone: {
              validators: {
                callback: {
                  message: i18n.global.t('formValidation.phone_number_not_valid'),
                  callback: (value, validator, $field) => {
                    let number = this.form.phone.replace(this.form.phone_code, '')
                    return number.trim().length ? true : false
                  }
                },
              }
            },
          },
          plugins: {
            trigger: new FormValidation.plugins.Trigger,
            bootstrap: new FormValidation.plugins.Bootstrap5({
              rowSelector: ".fv-row",
              eleInvalidClass: "",
              eleValidClass: ""
            })
          }
        })),
        a.push(FormValidation.formValidation(i, {
          fields: {
            ifu_file: {
              validators: {
                callback: {
                  message: i18n.global.t('formValidation.field_required'),
                  callback: (value, validator, $field) => {
                    let file = this.form.ifu_file[0]
                    return file ? true : false
                  }
                }
              }
            },
            rccm_file: {
              validators: {
                callback: {
                  message: i18n.global.t('formValidation.field_required'),
                  callback: (value, validator, $field) => {
                    let file = this.form.rccm_file[0]
                    return file ? true : false
                  }
                }
              }
            },
            address_file: {
              validators: {
                callback: {
                  message: i18n.global.t('formValidation.field_required'),
                  callback: (value, validator, $field) => {
                    let file = this.form.address_file[0]
                    return file ? true : false
                  }
                }
              }
            },
            condition: {
              validators: {
                callback: {
                  message: i18n.global.t('formValidation.field_required'),
                  callback: (value, validator, $field) => {
                    return !!this.form.condition
                  }
                }
              }
            }
          },
          plugins: {
            trigger: new FormValidation.plugins.Trigger,
            bootstrap: new FormValidation.plugins.Bootstrap5({
              rowSelector: ".fv-row",
              eleInvalidClass: "",
              eleValidClass: ""
            })
          }
        })),
        o.addEventListener("click", ((e) => {
          a[3].validate().then((async (t) => {
            if ("Valid" == t) {
              e.preventDefault()

              if (!this.form.condition) {
                window.toastr.error("Veuillez accepter les conditions générales d'utilisation")
              } else {
                o.disabled = !0
                await this.createAccount(this.form).then((res) => {
                  //*********************************************** */
                  if(this.dataInvoice.ifu || this.dataInvoice.tokenApi || this.dataInvoice.defaultTaxe){
                    this.addShopNormalizedKey({
                      data: {
                        ifu: this.dataInvoice.ifu,
                        invoice_type: 'FV',
                        tokenApi: this.dataInvoice.tokenApi,
                        defaultTaxe: this.dataInvoice.defaultTaxe
                      },
                      key: "symef-benin",
                      id: null
                    })
                  }
                  window.toastr.success(res.data.message)
                  o.removeAttribute("data-kt-indicator")
                  o.disabled = !1
                  r.goNext()
                }).catch(() => {
                  o.removeAttribute("data-kt-indicator")
                  o.disabled = !1
                  KTUtil.scrollTop()
                })
              }

            } else {
              Swal.fire({
                text: "Sorry, looks like there are some errors detected, please try again.",
                icon: "error",
                buttonsStyling: !1,
                confirmButtonText: "Ok, got it!",
                customClass: { confirmButton: "btn btn-light" }
              }).then((() => {
                KTUtil.scrollTop()
              }))
            }

          }))
        }))
    },

    inputChanged(number, phoneObject) {
      let errorDiv = document.querySelector('[data-field="responsable_phone"][data-field="responsable_phone"][data-validator="callback"]')
      if (errorDiv) {
        errorDiv.remove()
      }

      if (phoneObject) {
        this.form.society_phone = phoneObject.nationalNumber
        this.form.society_phone_code = '+' + phoneObject.countryCallingCode
      }
    },

    secondInputChanged(number, phoneObject) {
      let errorDiv = document.querySelector('[data-field="society_phone"][data-field="society_phone"][data-validator="callback"]')
      if (errorDiv) {
        errorDiv.remove()
      }
      if (phoneObject) {
        this.form.responsable_phone = phoneObject.nationalNumber
        this.form.responsable_phone_code = '+' + phoneObject.countryCallingCode
      }
    },

    inputCountryChanged(country) {
      this.form.society_phone_code = '+' + country.dialCode
    },

    secondInputCountryChanged(country) {
      this.form.responsable_phone_code = '+' + country.dialCode
    },

    thirstInputCountryChanged(country) {
      this.form.phone_code = '+' + country.dialCode
    },

    thirstInputChanged(number, phoneObject) {
      let errorDiv = document.querySelector('[data-field="admin_phone"][data-field="admin_phone"][data-validator="callback"]')
      if (errorDiv) {
        errorDiv.remove()
      }

      if (phoneObject) {
        this.form.phone = phoneObject.nationalNumber
        this.form.phone_code = '+' + phoneObject.countryCallingCode
      }
    },

    initSelect2() {
      $("select[data-control='select2']").select2()
      $("select[data-control='select2']").change((e) => {
        switch (e.target.name) {
          case 'city':
            this.form.city = e.target.value
            break
          case 'country':
            this.form.country = e.target.value
            const countryTrouve = this.getCountries.find(country => country.id === e.target.value)
            this.isBeninCountry = countryTrouve?.iso_alpha2 == 'BJ' ? true : false
            console.log(this.isBeninCountry)
            break
          case 'gender':
            this.form.gender = e.target.value
            break
          case 'type_taxe':
            this.dataInvoice.defaultTaxe = e.target.value
            break
          case 'responsable_gender':
            this.form.responsable_gender = e.target.value
            break

        }
      })
    },

  }

}
</script>

<style scoped>@media (max-width: 991px) {
  .step-none {
    display: none !important;
  }
}</style>